// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Retorno de Toku — splash mínimo mientras se confirma y se redirige a /pagos. */
.payst-main {
  display: grid;
  place-items: center;
  min-height: 50vh;
  padding: 24px;
}
.payst-card {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border: 1px solid var(--border);
  border-radius: var(--r-dialog);
  background: var(--bg-alt);
  color: var(--text-secondary);
  font-size: var(--fs-ui);
}
.payst-spin {
  width: 14px;
  height: 14px;
  border-radius: 999px;
  border: 2px solid var(--border);
  border-top-color: var(--text-secondary);
  animation: payst-spin 0.7s linear infinite;
}
@keyframes payst-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .payst-spin {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/pagos/PaymentStatus.css"],"names":[],"mappings":"AAAA,iFAAiF;AACjF;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;EAC/B,uCAAuC;EACvC,0CAA0C;AAC5C;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Retorno de Toku — splash mínimo mientras se confirma y se redirige a /pagos. */\n.payst-main {\n  display: grid;\n  place-items: center;\n  min-height: 50vh;\n  padding: 24px;\n}\n.payst-card {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 20px;\n  border: 1px solid var(--border);\n  border-radius: var(--r-dialog);\n  background: var(--bg-alt);\n  color: var(--text-secondary);\n  font-size: var(--fs-ui);\n}\n.payst-spin {\n  width: 14px;\n  height: 14px;\n  border-radius: 999px;\n  border: 2px solid var(--border);\n  border-top-color: var(--text-secondary);\n  animation: payst-spin 0.7s linear infinite;\n}\n@keyframes payst-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .payst-spin {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
